import { render, staticRenderFns } from "./NoSectionFound.vue?vue&type=template&id=93bc6290"
import script from "./NoSectionFound.vue?vue&type=script&lang=js"
export * from "./NoSectionFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports